import React from 'react';

export const CopyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9786 2.3999H5.36803C4.3954 2.3999 3.59961 3.18536 3.59961 4.14536V15.1635H5.36803V4.14536H15.9786V2.3999ZM18.6312 5.89081H8.90487C7.93224 5.89081 7.13645 6.67627 7.13645 7.63627V17.4544C7.13645 18.4144 7.93224 19.1999 8.90487 19.1999H18.6312C19.6038 19.1999 20.3996 18.4144 20.3996 17.4544V7.63627C20.3996 6.67627 19.6038 5.89081 18.6312 5.89081ZM18.6312 17.4544H8.90487V7.63627H18.6312V17.4544Z" fill="#5C6B73" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.5415 9.6001H13.058V11.8595H10.7998V13.343H13.058V15.6001H14.5415V13.343H16.7998V11.8595H14.5415V9.6001Z" fill="#5C6B73" />
  </svg>
);
